import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import {
  Button,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useRef, useState } from 'react';
import SendIcon from '@mui/icons-material/Send';
import { useDispatch } from 'react-redux';
import { reportIssue } from '../features/auth/authSlice';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { CloudUpload } from '@mui/icons-material';
function ContactSupport() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fileError, setFileError] = useState('');
  const [issueObj, setIssueObj] = useState({
    issue: '',
    description: '',
    attachment: null,
  });
  const inputRef = useRef();
  return (
    <>
      <div style={{ position: 'fixed', bottom: 4, right: 4, zIndex: 100 }}>
        <div
          className={`absolute right-2 bottom-5 sm:bottom-14 sm:right-8  ml-2
               rounded-lg  transition-all duration-700   origin-bottom-right
           text-end ${open ? 'opacity-100 scale-100 ' : 'opacity-0 scale-0'} 
        `}
          style={{
            height: open ? 600 : 0,
          }}
        >
          <IconButton
            className={`
          shadow-lg  bg-[#1e3a8a]
          transition-all duration-200
         ${open ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0 scale-0 hidden pointer-events-none'}
        `}
            onClick={() => {
              setOpen(false);
              setIssueObj({
                issue: '',
                description: '',
                attachment: null,
                status: false,
              });
            }}
          >
            <KeyboardArrowDownIcon className='text-white size-8  m-0' />
          </IconButton>
          <div className='border p-4 text-start shadow-lg rounded mt-2 bg-white min-w-80'>
            <Typography variant='h5' color='#1e3a8a'>
              Report issues here.
            </Typography>
            <Typography color='#1e3a8a' className='my-2'>
              You can enter any type of your queries and gets resolved quickly.
            </Typography>
            <div className='flex flex-col'>
              <Typography color='#1e3a8a' variant='body1'>
                Enter Issue
              </Typography>
              <div className='bg-[#EAEEFD] mb-1'>
                <TextField
                  disabled={loading}
                  size='small'
                  value={issueObj.issue}
                  fullWidth
                  onChange={(e) =>
                    setIssueObj((prev) => ({ ...prev, issue: e.target.value }))
                  }
                ></TextField>
              </div>
              <Typography color='#1e3a8a' variant='body1'>
                Description
              </Typography>
              <div className='bg-[#EAEEFD] mb-1'>
                <TextField
                  disabled={loading}
                  value={issueObj.description}
                  multiline
                  rows={3}
                  fullWidth
                  onChange={(e) =>
                    setIssueObj((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                ></TextField>
              </div>
              <Typography color='#1e3a8a' variant='body1'>
                Attachment
              </Typography>
              <Paper
                elevation={2}
                sx={{
                  p: 2,
                  border: '2px dashed #ccc',
                  textAlign: 'center',
                  backgroundColor: 'inherit',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (!loading) inputRef.current.click();
                }}
              >
                {!issueObj.attachment ? (
                  <CloudUpload sx={{ fontSize: 40, color: '#1976d2' }} />
                ) : (
                  <CheckCircleIcon
                    className='bg-white text-green-600 '
                    sx={{ fontSize: 40, color: '#1976d2', mb: 1 }}
                  />
                )}
                {!issueObj.attachment && (
                  <Typography>
                    <span
                      style={{ color: '#1976d2', textDecoration: 'underline' }}
                    >
                      browse
                    </span>
                  </Typography>
                )}
                <input
                  type='file'
                  ref={inputRef}
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    console.log(file);
                    if (file) {
                      const allowedTypes = [
                        'image/jpeg',
                        'image/png',
                        'image/jpg',
                      ];
                      const maxSize = 5 * 1024 * 1024;
                      if (!allowedTypes.includes(file.type)) {
                        setFileError('jpg,png,pdf only allowed');
                        return;
                      }
                      if (file.size > maxSize) {
                        setFileError('Max File size is 5MB');
                        return;
                      }
                    }
                    setFileError('');
                    setIssueObj((prev) => ({
                      ...prev,
                      attachment: file ?? null,
                    }));
                  }}
                />

                {issueObj.attachment && (
                  <Typography sx={{ mt: 1 }}>
                    Selected file: <b>{issueObj?.attachment?.name}</b>
                  </Typography>
                )}
              </Paper>
            </div>
            {fileError && (
              <Typography variant='body1' color='error'>
                {fileError}
              </Typography>
            )}
            {issueObj.status && (
              <div className='flex gap-2 mt-2'>
                <CheckCircleIcon className='bg-white text-green-600 ' />
                <Typography variant='body1' color='success'>
                  Issue submitted successfully
                </Typography>
              </div>
            )}
            <div className='text-end ml-auto mt-2'>
              <Button
                disabled={!issueObj?.issue || !issueObj?.description}
                loading={loading}
                loadingPosition='end'
                variant='contained'
                endIcon={<SendIcon />}
                onClick={async () => {
                  setLoading(true);
                  try {
                    const response = await dispatch(
                      reportIssue(issueObj),
                    ).unwrap();
                    if (response.status === 200) {
                      setIssueObj({
                        issue: '',
                        description: '',
                        status: true,
                        attachment: null,
                      });
                      if (inputRef.current) {
                        inputRef.current.value = '';
                      }
                      setLoading(false);
                      setTimeout(() => {
                        setIssueObj({
                          issue: '',
                          description: '',
                          status: false,
                        });
                      }, 7000);
                    }
                  } catch (error) {
                    console.log(error);
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                {loading ? 'Sending' : 'Send'}
              </Button>
            </div>
          </div>
        </div>

        <IconButton
          className={` relative
          shadow-lg  bg-[#1e3a8a] border
          transition-all duration-1000
         ${!open ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0 scale-0 pointer-events-none'}
        `}
          onClick={() => setOpen(true)}
        >
          <ContactSupportIcon className='text-[#EAEEFD] size-10'></ContactSupportIcon>
        </IconButton>
      </div>
    </>
  );
}
export default ContactSupport;
